import { Head, Link } from '@inertiajs/react'
import MainLayout from '../../components/layout/MainLayout'
import Button from '../../components/ui/Button'

export default function InternalServerError() {
  return (
    <MainLayout>
      <Head title="Erreur serveur - 500" />

      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-red-50 to-white px-4 py-20">
        <div className="text-center max-w-2xl">
          {/* Error Icon */}
          <div className="mb-8 inline-block">
            <svg className="w-32 h-32 mx-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Cercle de fond */}
              <circle cx="12" cy="12" r="10" fill="#EF4444" fillOpacity="0.1"/>

              {/* Cercle d'erreur */}
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#EF4444"
                strokeWidth="2"
              />

              {/* Croix */}
              <path
                d="M15 9L9 15"
                stroke="#EF4444"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
              <path
                d="M9 9L15 15"
                stroke="#EF4444"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {/* 500 */}
          <h1 className="text-8xl md:text-9xl font-bold text-red-600 mb-4">
            500
          </h1>

          {/* Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Erreur serveur
          </h2>

          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            Oups ! Une erreur inattendue s'est produite sur nos serveurs.
            Notre équipe technique a été automatiquement notifiée.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
            >
              ↻ Réessayer
            </button>
            <Link href="/">
              <Button variant="outline" size="lg">
                Retour à l'accueil
              </Button>
            </Link>
          </div>

          {/* Status Section */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-4">
              Ce que vous pouvez faire :
            </p>
            <ul className="text-sm text-gray-500 space-y-2 max-w-md mx-auto text-left">
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Actualisez la page dans quelques instants</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Retournez à la page d'accueil et réessayez</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Si le problème persiste, contactez notre support</span>
              </li>
            </ul>

            <div className="mt-6">
              <Link href="/contact" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                Contacter le support →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
